// extracted by mini-css-extract-plugin
export default {"container":"styles_container__RMKxH","child1":"styles_child1__4FQbx","child2":"styles_child2__xbH-A","child3":"styles_child3__oWycJ","visible":"styles_visible__EKgYu"};